"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
function TagComponents(props) {
    var tagType = props.tagType, tagTxt = props.tagTxt;
    var txt = tagTxt;
    var tagClass = '';
    switch (tagType) {
        case 'new':
            txt = 'NEW';
            tagClass = 'new-tag';
            break;
        case 'hot':
            txt = 'HOT';
            tagClass = 'hot-tag';
            break;
        default:
            break;
    }
    return tagType || tagTxt ? (react_1.default.createElement("div", { className: 'special-tag' },
        react_1.default.createElement("span", { className: "special-tag-txt ".concat(tagClass) }, txt))) : (react_1.default.createElement(react_1.default.Fragment, null));
}
function SmallCard(props) {
    var _a = (0, react_1.useState)(-1), active = _a[0], setActive = _a[1];
    var _b = props.smallCardList, smallCardList = _b === void 0 ? [] : _b;
    function handleClick(href) {
        if (!href)
            return;
        window.location.href = href;
    }
    return (react_1.default.createElement("div", { className: "small-card" }, smallCardList.map(function (item, index) {
        var title = item.title, desc = item.desc, _a = item.list, list = _a === void 0 ? [] : _a, btnTxt = item.btnTxt, btnHref = item.btnHref, tagTxt = item.tagTxt, backgroundUrl = item.backgroundUrl, _b = item.tagType, tagType = _b === void 0 ? '' : _b, extendProps = item.extendProps;
        return (react_1.default.createElement("div", { className: "list", key: index },
            react_1.default.createElement("div", __assign({ className: "item", style: {
                    backgroundImage: active === index && backgroundUrl ? "url(".concat(backgroundUrl, ")") : '',
                }, onMouseMove: function () {
                    setActive(index);
                }, onMouseOut: function () {
                    setActive(-1);
                }, onClick: function () { return handleClick(btnHref || ''); } }, (extendProps || {})),
                react_1.default.createElement("div", { className: "title" },
                    react_1.default.createElement("div", null, title)),
                react_1.default.createElement("div", { className: "desc" }, desc),
                react_1.default.createElement("ul", { className: "label" }, list.map(function (item, i) {
                    var txt = (item || {}).txt;
                    return (i < 3 && (react_1.default.createElement("li", { key: i, className: (0, classnames_1.default)('txt', { 'txt-more': i >= 1 }) },
                        ' ',
                        txt,
                        ' ')));
                })),
                btnTxt && (react_1.default.createElement("a", __assign({ href: btnHref, className: "href" }, (extendProps || {})), btnTxt)),
                react_1.default.createElement(TagComponents, { tagType: tagType, tagTxt: tagTxt }))));
    })));
}
exports.default = SmallCard;
//# sourceMappingURL=SmallCard.js.map